// Flow types automatically removed

import { Component } from 'react';
import { createRefetchContainer, graphql } from 'react-relay/legacy';
import { defineMessages, IntlContext, FormattedMessage } from 'dibs-react-intl';
import getter from 'dibs-object-getter';
import { SingleSelect } from 'dibs-elements/exports/SingleSelect';
import debounce from 'lodash/debounce';
const messages = defineMessages({
    placeholder: {
        id: 'abt.DesignerDirectorySearch.placeholder',
        defaultMessage: 'Search for a designer',
    },
});
export class DesignerDirectorySearchComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentRefetch: null,
            search: '',
            hasSearch: false,
            isLoading: false,
            selection: '',
        };
    }

    onInputChange = search => {
        if (!this.state.selection && search !== this.state.search) {
            this.setState(
                {
                    search: search,
                    hasSearch: search.length > 0,
                    isLoading: true,
                },
                this.fetchSuggestions
            );
        }
    };
    fetchSuggestions = debounce(() => {
        if (this.props.relay && !this.state.selection) {
            const { currentRefetch, hasSearch, search } = this.state;
            const { showOnlyTpnFirms, showTestFirms } = this.props;

            if (currentRefetch) {
                currentRefetch.dispose();
            }

            const refetchVariables = fragmentVariables => ({
                ...fragmentVariables,
                hasSearch,
                search,
                showOnlyTpnFirms,
                showTestFirms,
            });

            const onComplete = () =>
                this.setState({
                    currentRefetch: null,
                    isLoading: false,
                });

            this.setState({
                currentRefetch: this.props.relay.refetch(refetchVariables, null, onComplete),
            });
        }
    }, 250);

    render() {
        const { viewer } = this.props;
        const intl = this.context;
        const { hasSearch, isLoading, selection } = this.state;
        const options = (getter(viewer).at('designFirmResults').value('edges') || [])
            .map(edge => {
                if (edge && edge.node) {
                    const label = getter(edge).at('node').value('name');
                    const value = getter(edge).at('node').at('publicProfile').value('urlLabel');

                    if (label && value) {
                        return {
                            label,
                            value,
                        };
                    }
                }

                return null;
            })
            .filter(Boolean);
        return (
            <SingleSelect
                searchable
                clearable={hasSearch}
                isLoading={isLoading}
                options={options}
                dataTn="design-firms-search"
                name="design-firms-search"
                noResultsPrompt={
                    <FormattedMessage
                        id="abt.DesignerDirectorySearch.noResults"
                        defaultMessage="No Results Found"
                    />
                }
                onChange={option => {
                    if (option && option.value) {
                        window.location = `/design-firms/${option.value}/`;
                        this.setState({
                            selection: option.value,
                        });
                    }
                }}
                onInputChange={this.onInputChange}
                placeholder={intl.formatMessage(messages.placeholder)}
                value={selection}
                size="medium"
            />
        );
    }
}
DesignerDirectorySearchComponent.contextType = IntlContext;
export const DesignerDirectorySearch = createRefetchContainer(
    DesignerDirectorySearchComponent,
    {
        viewer: graphql`
            fragment DesignerDirectorySearch_viewer on Viewer {
                designFirmResults: designFirms(
                    firmName: $search
                    showOnlyTpnFirms: $showOnlyTpnFirms
                    showTestFirms: $showTestFirms
                ) @include(if: $hasSearch) {
                    edges {
                        node {
                            name
                            publicProfile {
                                urlLabel
                            }
                        }
                    }
                }
            }
        `,
    },
    graphql`
        query DesignerDirectorySearchRefetchQuery(
            $search: String!
            $hasSearch: Boolean!
            $showOnlyTpnFirms: Boolean
            $showTestFirms: Boolean
        ) {
            viewer {
                ...DesignerDirectorySearch_viewer
            }
        }
    `
);
